import "react-toastify/dist/ReactToastify.css";
import "./unsubscribePage.css"; // Importing CSS

import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";

import axios from "axios";
import config from "./config";
import { isGWAT } from "./utils/is-gwat";

const UnsubscribePage = () => {
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token"); // Get token from query parameters

  const logoSrc = isGWAT() ? "/gwat/logo.svg" : "/dealsaway/logo.svg";

  const hasChecked = groups.some((group) => group.unsubscribed === true);

  useEffect(() => {
    if (!token) {
      toast.error("Token is not provided.");
    } else {
      setIsLoading(true);
      // Fetch groups
      axios
        .get(`${config.emailUnsubscribeServiceUrl}/subscriptions`, {
          params: {
            token,
          },
        })
        .then((response) => {
          setGroups(response.data?.data);
        })
        .catch((error) => {
          console.error("Error fetching groups:", error);
          toast.error("Error fetching groups. Please try again later.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [token]);

  const handleUnsubscribeAll = () => {
    setIsSubmitting(true);
    const allUnsubcribedGroups = groups.map((group) => {
      return { name: group.name, unsubscribed: true };
    });
    axios
      .patch(
        `${config.emailUnsubscribeServiceUrl}/subscriptions`,
        { subscriptions: allUnsubcribedGroups },
        {
          params: {
            token,
          },
        }
      )
      .then(() => {
        setGroups(allUnsubcribedGroups); // Update the state of all groups
        toast.success("Successfully unsubscribed from all groups.");
      })
      .catch((error) => {
        console.error("Error unsubscribing from all groups:", error);
        toast.error(
          "Error unsubscribing from all groups. Please try again later."
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleSubmitChanges = () => {
    setIsSubmitting(true);
    axios
      .patch(
        `${config.emailUnsubscribeServiceUrl}/subscriptions`,
        { subscriptions: groups },
        {
          params: {
            token,
          },
        }
      )
      .then(() => {
        toast.success("Changes submitted successfully.");
      })
      .catch((error) => {
        console.error("Error submitting changes:", error);
        toast.error("Error submitting changes. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleCheckboxChange = (index) => {
    setGroups(
      groups.map((group, i) =>
        i === index ? { ...group, unsubscribed: !group.unsubscribed } : group
      )
    );
  };

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-form">
        {isSubmitting && <div className="loader-line"></div>}
        <div className="logo-wrapper">
          <img src={logoSrc} alt="Logo" className="logo" />
        </div>

        <div className="unsubscribe-form-header">
          <img src="/unsubIcon.svg" alt="Unsubscribe" className="unsub-icon" />

          <h1>We’re Sad To See You Go!</h1>
          <p>This is the place to unsubscribe from the following groups</p>
        </div>
        <div className="unsubscribe-form-groups">
          {isLoading ? (
            <>
              <div className="unsubscribe-form-groups-skeleton"></div>
              <div className="unsubscribe-form-groups-skeleton half-width only-mobile"></div>
            </>
          ) : (
            groups.map((group, index) => (
              <div key={group.name} className="group">
                <input
                  type="checkbox"
                  id={group.name}
                  checked={group.unsubscribed}
                  onChange={() => handleCheckboxChange(index)}
                />
                <label htmlFor={group.name}>
                  {" "}
                  Tick this box to unsubscribe from{" "}
                  <strong>{group.name}</strong> emails
                </label>
              </div>
            ))
          )}
        </div>
        <div className="unsubscribe-form-notice">
          * Make sure to click "Submit Changes" or "Unsubscribe from All" to
          save your preferences.
        </div>
        <div className="unsubscribe-form-actions">
          <button
            id="submitChanges"
            onClick={handleSubmitChanges}
            disabled={isLoading || !hasChecked}
          >
            Submit Changes
          </button>
          <button
            id="unsubscribeAll"
            onClick={handleUnsubscribeAll}
            disabled={isLoading}
          >
            Unsubscribe from All
          </button>
        </div>
      </div>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default UnsubscribePage;
